import { priceSnapshotResponse, type PriceSnapshotItem } from '@/api/schemas';
import { requestParsed } from '@/api/http';
import type { Market } from '@/domain/side';

/** A snapshot's market: Binance's spot and usdm, OKX's spot and USDT swaps. */
export type SnapshotMarket = Market | 'okx-spot' | 'okx-swap';

/**
 * The last price of every symbol of a market (spot, usdm when the API has a futures feed, okx-spot and okx-swap when it
 * has OKX prices), to seed the price store before (and after every gap in) live ticks.
 */
export function fetchPriceSnapshot(market: SnapshotMarket, signal?: AbortSignal): Promise<PriceSnapshotItem[]> {
  return requestParsed(priceSnapshotResponse, '/Prices/snapshot', { query: { market }, ...(signal ? { signal } : {}) });
}
